<div class="attachments">
  <input
    nbInput
    fieldSize="small"
    placeholder="Поиск вложений" i18n-placeholder="@@SearchVersion"
    (keyup)="filterSidebarFilter($event)"
  />

  <span class="files-counter clr-black-base fs-16 fw-400">
		<nb-icon icon="attach-outline"/>
    {{ damItemVersions?.length }} {{ createLabel(damItemVersions.length, 'версия|версии|версий') }}
	</span>

  <div class="attachments-checkboxes">
    <ng-container *ngFor="let file of fileExtensions; index as i">
      <nb-checkbox
        (checkedChange)="onFileExtensionToggle(i)"
      >
        {{ file?.typeOfFile }} ({{ file?.count }})
      </nb-checkbox>
    </ng-container>
  </div>

  <div
    class="attachments-list"
    *ngIf="damItemVersions && damItemVersions?.length>0"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
  >
    <ng-container
      *ngFor="let version of filterVersions(damItemVersions)"
    >
      <ng-container
        *ngIf="version?.hideExpression==undefined || version.hideExpression==false"
      >
        <div
          class="attachments-item"
          [ngClass]="{
            'active': version.id === currentVersion
          }"
          (click)="selectVersion(version)"
          cdkDrag
        >
          <div class="attachments-item__row">
            <div class="attachments-item__img-container">
              <app-secured-image
                *ngIf="showThumbnail(version.mimeType)"
                src="/dam/get-image-dynamic-version/{{version.id}}"
              ></app-secured-image>
              <img
                *ngIf="!showThumbnail(version.mimeType)"
                style="max-width: 100px;object-fit: contain;width: 100%;height: 100%;" src="/assets/images/dam/vivid/{{getExtension(version)}}.svg"
                alt=""
              />
            </div>

            <div class="attachments-item-buttons">
              <button nbButton size="small" status="primary" (click)="download(version.id, version.header)">
                <nb-icon icon="download"/>
                <span i18n="@@Download">Скачать</span>
              </button>
              <button nbButton size="small" (click)="getExif(version.id, version?.iid); ExifDialog.openDialog()">
                Exif
              </button>
            </div>
          </div>

          <hr class="divider-horizontal"/>

          <span class="attachments-item__row clr-black-base">
            {{ version.header }} <a nbTooltip="Переименовать" i18n-nbTooltip="@@Rename" class="pointer cursor-pointer" (click)="modalRename(version?.id, version?.header)"><nb-icon icon="edit"></nb-icon></a>
				</span>

          <div class="attachments-item__row">
            <div class="attachments-item-characteristics">
						<span
              class="file-type txt-white-base fs-11"
              [ngClass]="version?.header.split('.').pop()"
            >
							.{{ version?.header.split('.').pop() }}
						</span>
              <!--            <span class="clr-black-sec">-->
              <!--							1875 x 1875 px-->
              <!--						</span>-->
              <span class="clr-black-sec">
							{{ formatBytes(version?.size) }}
						</span>
              <span class="clr-black-sec">
							{{ version.createdAt | date : 'dd.MM.yyyy' }}
						</span>
            </div>

            <span
              (click)="getHistory(version); VersionHistoryDialog.openDialog();"
              class="attachments-item-change-history clr-grey-sec underline"
              i18n="@@ProductChanges"
            >
						История изменений
					</span>
          </div>
        </div>

      </ng-container>
    </ng-container>
  </div>
</div>
<div class="attachments-list" *ngIf="damItemVersions && damItemVersions?.length==0">
  <div>Версий не найдено</div>
</div>

<app-dialog-wrapper #ExifDialog>
  <div class="dialog">
    <h2 class="dialog-tittle">
      <span i18n="@@VersionExif">Exif данные версии</span>: {{ exifIid }}
    </h2>

    <div class="dialog-list">
      <ng-container *ngIf="documentExifList?.length; else noExif">
        <div class="exif-item" *ngFor="let exif of documentExifList">
          <div>
            {{ exif.tag }}
          </div>
          <div>
            {{ exif.description }}
          </div>
          <div>
            {{ exif.directory }}
          </div>
        </div>
      </ng-container>

      <ng-template #noExif>
        <div i18n="@@ExifIsMissing">
          Exif отсутствует
        </div>
      </ng-template>
    </div>
  </div>
</app-dialog-wrapper>

<app-dialog-wrapper #VersionHistoryDialog>
  <div class="dialog">
    <h2 class="dialog-tittle" i18n="@@History">
      История версий DAM элемента
    </h2>

    <div class="dialog-list scroll-brand">
      <ng-container *ngIf="damItemVersions?.length; else noVersion">
        <div class="version-item" *ngFor="let version of versionsHistory;">
          <app-secured-image *ngIf="showThumbnail(version.mimeType)" src="/dam/get-image-dynamic-version-history/{{version.id}}"></app-secured-image>
          <img *ngIf="!showThumbnail(version.mimeType)" style="max-width:100px" src="/assets/images/dam/vivid/{{getExtension(version)}}.svg" alt="">


          <div class="f-main version-item-info">
            <!--						<span class="version-item-info__version" [ngClass]="'is-actual'" i18n="@@ActualVersion">-->
            <!--							Актуальная версия-->
            <!--						</span>-->
            <div *ngIf="clickedDamItemVersion.documentId === version.documentId" style="color:forestgreen">
              <span class="version-item-info__version" [ngClass]="'is-actual'" i18n="@@ActualVersion">
							Актуальная версия
						</span></div>
            <div *ngIf="clickedDamItemVersion.documentId !== version.documentId" style="color:forestgreen">
              <a *ngIf="write" (click)="makeActual(version.id)" nbButton>Сделать версию актуальной</a>
            </div>
            <span class="fs-16 fw-600 clr-black-base">
							{{ version.header }} {{ version.iid }} isOriginal
						</span>
            <span class="clr-grey-sec fs-14 fw-500">
							{{ version.mimeType }}  {{ formatBytes(version?.size) }}
						</span>
            <div class="flex g-8">
							<span class="clr-grey-sec fs-14 fw-500" i18n="@@Sorting_updatedAt_desc">
								Дата изменений
							</span>
              <span class="clr-black-base fs-14 fw-500"> </span>
              {{ version.createdAt | date: 'dd.MM.yyy hh:mm' }}
              <nb-icon icon="person-outline"/>
              <!--              Алексей Стахович-->
            </div>
            <div class="flex g-8">
							<span class="clr-grey-sec fs-14 fw-500" i18n="@@Updated">
								Дата загрузки
							</span>
              <span class="clr-black-base fs-14 fw-500">
								{{ version.createdAt | date: 'dd.MM.yyy hh:mm' }}
                <nb-icon icon="person-outline"/>
                <!--								Алексей Стахович-->
							</span>
            </div>
          </div>
        </div>

        <!--        <div class="version-item" *ngFor="let version of versionsHistory;">-->
        <!--          <app-secured-image *ngIf="showThumbnail(version.mimeType)" src="/dam/get-image-dynamic-version-history/{{version.id}}"></app-secured-image>-->
        <!--          <img *ngIf="!showThumbnail(version.mimeType)" style="max-width:100px" src="/assets/images/dam/vivid/{{getExtension(version)}}.svg" alt="">-->

        <!--          <div class="f-main version-item-info">-->
        <!--						<span class="version-item-info__version" i18n="@@PreviousVersion">-->
        <!--							Предыдущая версия-->
        <!--						</span>-->
        <!--            <span class="fs-16 fw-600 clr-black-base">-->
        <!--							{{version.header}} {{version.iid}} isOriginal-->
        <!--						</span>-->
        <!--            <span class="clr-grey-sec fs-14 fw-500">-->
        <!--							{{version.mimeType}} {{version.size}}mb exif-->
        <!--						</span>-->
        <!--            <div class="flex g-8">-->
        <!--							<span class="clr-grey-sec fs-14 fw-500" i18n="@@Updated">-->
        <!--								Дата изменений-->
        <!--							</span>-->
        <!--              <span class="clr-black-base fs-14 fw-500"> </span>-->
        <!--              {{version.createdAt | date: 'dd.MM.yyy hh:mm'}}-->
        <!--              <img src="assets/icons/person.svg" alt="" />-->
        <!--&lt;!&ndash;              Алексей Стахович&ndash;&gt;-->
        <!--            </div>-->
        <!--            <div class="flex g-8">-->
        <!--							<span class="clr-grey-sec fs-14 fw-500" i18n="@@Updated">-->
        <!--								Дата загрузки-->
        <!--							</span>-->
        <!--              <span class="clr-black-base fs-14 fw-500" >-->
        <!--								{{version.createdAt | date: 'dd.MM.yyy hh:mm'}}-->
        <!--                <img src="assets/icons/person.svg" alt="" />-->
        <!--&lt;!&ndash;								Алексей Стахович&ndash;&gt;-->
        <!--							</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </ng-container>

      <ng-template #noVersion>
        <div>
          version отсутствует
        </div>
      </ng-template>
    </div>
  </div>
</app-dialog-wrapper>
